(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-tour"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initDeck(deck, name, strings) {
    var slides = Array.prototype.slice.call(deck.querySelectorAll('[data-tour-slide]'));
    var prev = deck.querySelector('[data-tour-prev]');
    var next = deck.querySelector('[data-tour-next]');
    var dots = deck.querySelector('[data-tour-dots]');
    var caption = deck.querySelector('[data-tour-caption]');
    var count = slides.length;
    var current = 0;
    if (count < 2) deck.classList.add('feature-tour__deck--single');
    dots.innerHTML = '';
    slides.forEach(function (slide, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'feature-tour__dot';
      dot.setAttribute('aria-label', strings.show.replace('[number]', i + 1).replace('[total]', count).replace('[name]', name));
      dot.addEventListener('click', function () { show(i); });
      dots.appendChild(dot);
    });
    var dotButtons = Array.prototype.slice.call(dots.children);

    function show(i) {
      current = Math.max(0, Math.min(count - 1, i));
      slides.forEach(function (slide, j) {
        slide.classList.toggle('is-on', j === current);
        slide.setAttribute('aria-hidden', j === current ? 'false' : 'true');
      });
      dotButtons.forEach(function (dot, j) {
        if (j === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === count - 1;
      var text = slides[current] ? slides[current].dataset.caption : '';
      if (count > 1) text += ' · ' + strings.of.replace('[number]', current + 1).replace('[total]', count);
      if (caption) caption.textContent = text;
    }

    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    show(0);
  }

  function initTour(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-tour-step]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-tour-chip]'));
    var chipList = root.querySelector('.feature-tour__chip-list');
    var stage = root.querySelector('[data-tour-stage]');
    var stringsEl = root.querySelector('[data-tour-strings]');
    var strings = { of: stringsEl.dataset.of, show: stringsEl.dataset.show };
    if (!steps.length) return;

    // The sticky window on wide screens shows a copy of each feature's picture deck.
    var stageDecks = steps.map(function (step) {
      var copy = step.querySelector('[data-tour-deck]').cloneNode(true);
      stage.appendChild(copy);
      return copy;
    });
    steps.forEach(function (step, i) {
      initDeck(step.querySelector('[data-tour-deck]'), step.dataset.name, strings);
      initDeck(stageDecks[i], step.dataset.name, strings);
    });

    var chipBar = root.querySelector('.feature-tour__chips');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Load the pictures for the features either side, so a switch never shows an empty frame.
    function warm(k) {
      var deck = stageDecks[k];
      if (!deck || deck.dataset.warm === 'true') return;
      deck.dataset.warm = 'true';
      deck.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }

    var active = -1;
    function setActive(i) {
      if (i === active) return;
      active = i;
      steps.forEach(function (step, k) { step.classList.toggle('is-active', k === i); });
      stageDecks.forEach(function (deck, k) { deck.classList.toggle('is-live', k === i); });
      warm(i - 1);
      warm(i + 1);
      chips.forEach(function (chip, k) {
        if (k === i) chip.setAttribute('aria-current', 'true');
        else chip.removeAttribute('aria-current');
      });
      var chip = chips[i];
      if (chip && chipList.scrollWidth > chipList.clientWidth) {
        chipList.scrollTo({
          left: chip.offsetLeft - chipList.clientWidth / 2 + chip.offsetWidth / 2,
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      }
    }

    // In focus = the feature whose middle is nearest the middle of the open screen (below the
    // sticky header and chips). Same rule both ways, so scrolling up matches scrolling down.
    // A small dead zone stops it flickering when two features are about equally close.
    var locked = false;
    function readingLine(height) {
      return (Math.max(0, chipBar.getBoundingClientRect().bottom) + height) / 2;
    }

    function pick() {
      if (locked) return;
      var height = window.innerHeight;
      var line = readingLine(height);
      var distances = steps.map(function (step) {
        var box = step.getBoundingClientRect();
        return Math.abs((box.top + box.bottom) / 2 - line);
      });
      var index = distances.indexOf(Math.min.apply(Math, distances));
      if (steps[steps.length - 1].getBoundingClientRect().bottom <= height) {
        setActive(steps.length - 1);
        return;
      }
      if (active >= 0 && index !== active && distances[active] - distances[index] < height * 0.04) return;
      setActive(index);
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; pick(); });
    }, { passive: true });
    window.addEventListener('resize', pick);

    // A chip jump holds its feature in focus until the page stops moving, so the window
    // doesn't flash through every feature it passes on the way.
    var unlockTimer = 0;
    function unlock() {
      window.clearTimeout(unlockTimer);
      window.removeEventListener('scrollend', unlock);
      if (!locked) return;
      locked = false;
      pick();
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function (event) {
        event.preventDefault();
        var i = Number(chip.dataset.tourChip);
        var reduce = reduceMotion.matches;
        var heading = steps[i].querySelector('.feature-tour__step-heading');
        setActive(i);
        locked = true;
        window.clearTimeout(unlockTimer);
        if ('onscrollend' in window) window.addEventListener('scrollend', unlock);
        unlockTimer = window.setTimeout(unlock, reduce ? 100 : 1600);
        // Centre the feature when it fits on screen; otherwise line its heading up at the top.
        var room = window.innerHeight - chipBar.getBoundingClientRect().height;
        var fits = steps[i].offsetHeight < room;
        steps[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: fits ? 'center' : 'start' });
        window.setTimeout(function () { heading.focus({ preventScroll: true }); }, reduce ? 0 : 700);
      });
    });

    setActive(0);
    pick();
  }

  function initAll() {
    document.querySelectorAll('[data-feature-tour]').forEach(initTour);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pricing-plans"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPricingPlans(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var billing = root.querySelector('.pricing-plans__billing');
    if (!billing) return;

    var options = billing.querySelectorAll('.pricing-plans__toggle-option');
    var status = billing.querySelector('.pricing-plans__status');

    function apply(mode, announce) {
      options.forEach(function (option) {
        option.setAttribute('aria-pressed', option.dataset.billing === mode ? 'true' : 'false');
      });

      root.querySelectorAll('[data-billing-show]').forEach(function (element) {
        element.toggleAttribute('hidden', element.dataset.billingShow !== mode);
      });

      root.querySelectorAll('[data-href-monthly]').forEach(function (link) {
        var href = mode === 'annual' ? link.dataset.hrefAnnual : link.dataset.hrefMonthly;
        if (href) link.setAttribute('href', href);
      });

      if (status && announce) {
        status.textContent = mode === 'annual' ? billing.dataset.statusAnnual : billing.dataset.statusMonthly;
      }
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        apply(option.dataset.billing, true);
      });
    });

    apply('monthly', false);
  }

  function initAll() {
    document.querySelectorAll('.pricing-plans').forEach(initPricingPlans);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVideoHero(hero) {
    var video = hero.querySelector('video.video-hero__media');
    var toggle = hero.querySelector('.video-hero__toggle');
    if (!video || !toggle || toggle.dataset.initialized === 'true') return;
    toggle.dataset.initialized = 'true';

    var label = toggle.querySelector('.visually-hidden');
    var iconPause = toggle.querySelector('.video-hero__icon--pause');
    var iconPlay = toggle.querySelector('.video-hero__icon--play');

    function render() {
      var paused = video.paused;
      iconPause.toggleAttribute('hidden', paused);
      iconPlay.toggleAttribute('hidden', !paused);
      label.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
    }

    toggle.addEventListener('click', function () {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
    video.addEventListener('play', render);
    video.addEventListener('pause', render);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }
    render();
  }

  function initAll() {
    document.querySelectorAll('.video-hero').forEach(initVideoHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
